import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Link } from 'components/Common';
import { isiOS } from 'config';

const StyledLinkRow = styled.div`
  background: white;
  font-size: 18px;
  ${({ theme }) =>
    isiOS
      ? css`
          && {
            padding: 12px ${theme.edgeDistance};
          }
          & div {
            display: inline-block;
          }

          ${({ showArrow }) =>
            showArrow
              ? css`
                  &:after {
                    border-style: solid;
                    border-width: 0.1em 0.1em 0 0;
                    border-color: ${theme.borderColor};
                    content: '';
                    display: inline-block;
                    float: right;
                    margin-right: 5px;
                    height: 0.45em;
                    left: 0;
                    position: relative;
                    top: 0.3em;
                    transform: rotate(45deg);
                    vertical-align: top;
                    width: 0.45em;
                  }
                `
              : ''}
        `
      : css`
          padding: ${theme.edgeDistance};
        `}
`;

const LinkRow = ({ pageDirection, text, to, showArrow = true, onClick }) => {
  const body = (
    <StyledLinkRow showArrow={showArrow} onClick={onClick}>
      {text}
    </StyledLinkRow>
  );
  return to ? (
    <Link to={to} pageDirection={pageDirection}>
      {body}
    </Link>
  ) : (
    body
  );
};

LinkRow.propTypes = {
  pageDirection: PropTypes.string,
  text: PropTypes.node.isRequired,
  to: PropTypes.string,
  onClick: PropTypes.func
};

export default LinkRow;
